import { pessoa_fisica_empty } from "@/modules/pessoas_fisica/store/getters.js";

export const getPagination = ({ pagination }) => pagination;
export const conselheiro_empty = () => ({
  conselho_id: null,
  grupo_entidade_id: null,

  pessoa_fisica_id: null,
  pessoa_fisica: pessoa_fisica_empty(),

  pessoa_juridica_id: null,
  pessoa_juridica: {},

  mandato_id: null,
  mandato: {},

  titular_id: null,
  titular: {},

  funcao: "titular",
  cargo: null,

  titular_id: null,
  titular: {},
});
